export const TRANSACTION_DATE_FORMAT_ERROR =
  "Dates should be entered as MM/DD/YYYY";
export const TRANSACTION_DATE_FUTURE_DATE_ERROR =
  "Enter today or a date in the past.";
export const AMOUNT_ERROR =
  "Double check that amount. It should be more than $0 and less than $21 million. That would be one amazing business trip.";
